import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

export interface OnAccountGoodStateActionMessage {
    mailboxInfo: MailboxInfo;
}
const defaultExport: (mailboxInfo: MailboxInfo) => OnAccountGoodStateActionMessage = action("onAccountGoodState", (mailboxInfo: MailboxInfo): OnAccountGoodStateActionMessage => ({
    mailboxInfo,
}));
export default defaultExport;
